export const UnTransferredMessages = {
    //Her kan man legge inn intl-nøkler under utvikling.
    nb: {
        'feilmelding.ingen-url-treff': 'Siden finnes ikke',

        'button.to-startpage': 'Tilbake til startsiden',

        'feilmelding.missing-rights-to-view-name':
            'Du mangler rettighet til å se detaljert info om eier av merke',
        'button-back': 'Tilbake',
        'button-start-page': 'Til forsiden',
        'search-page.title-2': 'Velg reinbeiteområde og distrikt',
        'search-page.info-text':
            'Trykk der du vil velge snitt. Bruk pilene for å bytte mellom høyre og venstre øre.',
        'result-page.expand-search': 'Prøv utvidet søk',
        'result-page.expand-search-text': 'Fant du ikke merket du lette etter?',
        'search-page.choose-cut-2': 'Velg snitt',
        'select-cut-combination.header':
            'Bruk markert snitt, eller velg en annen snittkombinasjon',
        'feilmelding.unsupported-device':
            'Installer applikasjonen for offline-modus',
        'feilmelding.unsupported-device-content':
            'Denne enheten/nettleseren støtter ikke nedlastning. Dersom du ønsker å laste ned applikasjonen på din enhet, kan du forsøke med en annen nettleser. ',
        'feilmelding.unsupported-device-content-pc':
            'For å installere applikasjonen, trykk på',
        'select-cut-alert-limit-results':
            'Velg reinbeiteområde/distrikt for å begrense antall snitt.',
        'log-in.alert-no-internet-header': 'Du er frakoblet internett',
        'log-in.alert-no-internet':
            'Du trenger internett-tilgang for å kunne logge inn.',
        'component.header.language': 'Språk',
        'saved-eartags.no-tags':
            'Søk frem reinmerker og trykk på hjertesymbolet på merkene du er interessert i. Du vil finne merkene igjen her.',
        'alert.download.text-apple':
            'For å legge til på Hjem-skjermen, trykk på ',
        'alert.download.text3-apple': 'Legg til på Hjem-skjermen.',
        'alert.download.title-apple':
            'Legg til på Hjem-skjermen for offline-modus'
    }
};
